import { geckoPerms, type RolodexPermissionsValues } from 'types'

export interface PermissionGateSpec {
  /** Any one of these unlocks the target; empty or absent means no requirement. */
  requires?: ReadonlyArray<RolodexPermissionsValues>
  /** Holding any of these hides the target, unless the user is a Gecko member. */
  except?: ReadonlyArray<RolodexPermissionsValues>
}

// `geckoPerms` is typed as plain strings; PermissionsGate narrows it the same way.
const GECKO_PERMISSIONS = geckoPerms as RolodexPermissionsValues[]

/**
 * The gate decision behind `PermissionsGate`, as a plain function so lists
 * built in hooks hide exactly what the sidebar hides.
 */
export function isPermittedByGate(
  hasPermissions: (permissions: RolodexPermissionsValues[]) => boolean,
  gate: PermissionGateSpec
): boolean {
  if (gate.requires?.length && !hasPermissions([...gate.requires])) {
    return false
  }
  if (
    gate.except?.length &&
    hasPermissions([...gate.except]) &&
    !hasPermissions(GECKO_PERMISSIONS)
  ) {
    return false
  }
  return true
}
